import { useCurrentUser } from '#app/hooks/useCurrentUser.js';

type UseWorkspacesValue = {
  hasClientWorkspace: boolean;
  hasContractorWorkspace: boolean;
  wasRemovedFromClientWorkspace: boolean;
};

export const useWorkspaces = (): UseWorkspacesValue => {
  const currentUser = useCurrentUser();

  const clientWorkspace = currentUser?.workspaces.find(
    (workspace) => workspace.__typename === 'ClientWorkspace',
  );

  const hasAccessToClientWorkspace =
    clientWorkspace?.visitorMember?.enabledFeatures.includes(
      'HAS_ACCESS_TO_WORKSPACE',
    ) ?? false;

  const hasClientWorkspace =
    (clientWorkspace && hasAccessToClientWorkspace) ?? false;

  const hasContractorWorkspace =
    currentUser?.workspaces.some(
      (workspace) => workspace.__typename === 'ContractorWorkspace',
    ) ?? false;

  return {
    hasClientWorkspace,
    hasContractorWorkspace,
    wasRemovedFromClientWorkspace:
      (clientWorkspace && !hasAccessToClientWorkspace) ?? false,
  };
};
